var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 25H17.667C19.1398 25 20.3337 23.8061 20.3337 22.3333V9.55229C20.3337 9.19866 20.1932 8.85952 19.9431 8.60948L12.7242 1.39052C12.4741 1.14048 12.135 1 11.7814 1H4.33366C2.8609 1 1.66699 2.19391 1.66699 3.66667V18.3333M1.66699 25L8.1719 18.4951M8.1719 18.4951C8.89576 19.219 9.89576 19.6667 11.0003 19.6667C13.2095 19.6667 15.0003 17.8758 15.0003 15.6667C15.0003 13.4575 13.2095 11.6667 11.0003 11.6667C8.79119 11.6667 7.00033 13.4575 7.00033 15.6667C7.00033 16.7712 7.44804 17.7712 8.1719 18.4951Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon2);
export default __webpack_public_path__ + "static/media/appIcon2.70b360920f95d7d76f46294ca71a5a81.svg";
export { ForwardRef as ReactComponent };